<div class="product-price">
  @if (price().isLoading) {
    <skeleton-loading class="price-loading" />
  } @else if (!price().data) {
    <div class="content">
      <span class="content-message">
        {{ 'product.unavaliblePrice' | translate }}
      </span>
    </div>
  } @else if (price().data) {
    <div class="content">
      <div class="price-container">
        <p>
          <span>{{ 'product.price.nf' | translate }}</span> / UN
        </p>

        <div class="price">
          @if (showStrikethrough()) {
            <span class="price-discount">{{ price().data?.formatedPrice }} </span>
          }
          <span class="price-final">{{ price().data?.formatedFinalPrice }}</span>
        </div>
      </div>
    </div>
  }

  @if (price().isLoading) {
    <div class="details">
      <skeleton-loading class="detail-group-loading" />
      <skeleton-loading class="detail-group-loading" />
    </div>
  } @else {
    <div class="details">
      <div class="details-group">
        <div class="details-group__line">
          <strong>{{ 'product.price.base' | translate }}</strong>
          <span>{{ price().data?.formatedPrice || 'R$ 0,00' }}</span>
        </div>
        <div class="details-group__line">
          <strong>{{ 'product.price.discount' | translate }}</strong>
          <span>{{ price().data?.formatedDiscount || 'R$ 0,00' }}</span>
        </div>
        <div class="details-group__line">
          <strong>{{ 'product.price.final' | translate }}</strong>
          <span>{{ price().data?.formatedFinalPrice || 'R$ 0,00' }}</span>
        </div>
      </div>

      <div class="details-group">
        <div class="details-group__line">
          <strong>{{ 'product.price.st' | translate }}</strong>
          <span>{{ price().data?.formatedST || 'R$ 0,00' }}</span>
        </div>
        <div class="details-group__line">
          <strong>{{ 'product.price.ipi' | translate }}</strong>
          <span>{{ price().data?.formatedIPI || 'R$ 0,00' }}</span>
        </div>
        <div class="details-group__line">
          <strong>{{ 'product.price.icms' | translate }}</strong>
          <span>{{ price().data?.formatedICMS || 'R$ 0,00' }}</span>
        </div>
      </div>
    </div>
  }

  @if (stock().isLoading) {
    <skeleton-loading class="status-loading" />
  } @else {
    <div class="status">
      <product-stock [has]="!!stock().data?.available" [labelable]="true" />
    </div>
  }
</div>
